<template>
  <div v-if="bannerList.length > 0" class="app">
    <!-- 顶部右上角app下载按钮 -->
    
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i @click="$parent.goNav('/hongbao')" class="grab"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />
    </div>


    <div class="topAppApp" ref="topHeight">
    <!-- app下载 -->
      <div class="appbox" v-if="appshow">
        <!-- <img class="colse" @click="appshow = false" src="/static/image/hongbaocolse.png" alt="" /> -->
        <i  @click="appshow = false" class="lobby-image lobby-image lobby-image--skeleton colse" data-load-strategy="loading-set@0:lazy@0" data-status="success" data-thumb="0" data-id="ce36eab3-6f39-4139-8f97-9c2d767218a9" data-src="/siteadmin/skin/lobby_asset/common/web/common/comm_icon_x.svg" style="display: inline-flex; justify-content: center; align-items: center;">
          <svg width="1em" height="1em" fill="#8" class="#866638" viewBox="0 0 16 16">
          <g id="5506ee082c90bced455ea194c764a663-comm_icon_x" transform="translate(-1209.5 -160.5)">
            <path id="5506ee082c90bced455ea194c764a663-Line_14" data-name="Line 14" d="M14,15a1,1,0,0,1-.707-.293l-14-14a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0l14,14A1,1,0,0,1,14,15Z" transform="translate(1210.5 161.5)"></path>
            <path id="5506ee082c90bced455ea194c764a663-Line_15" data-name="Line 15" d="M0,15a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414l14-14a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-14,14A1,1,0,0,1,0,15Z" transform="translate(1210.5 161.5)"></path>
          </g>
        </svg></i>
        <img class="logo" v-if="$store.state.appInfo.site_logo" :src="$store.state.appInfo.site_logo" alt="" />
        <div class="testz">
          <div class="tit">下载APP豪礼领不停</div>
          <div class="cx">全网公平、公正、公开、无私彩</div>
        </div>
        <button class="top-download-btn" v-if="appshow" @click="$parent.goNav('/app')">立即下载</button>
      </div>
      <div class="appbox1">
        <img class="logo" v-if="$store.state.appInfo.site_logo" :src="$store.state.appInfo.site_logo" alt="" />
        <div class="testz1">
          <div class="tit">{{ $store.state.appInfo.title }}</div>
          <div class="cx">91fa.net</div>
        </div>
        <div style="color: #866638;">开云娱乐官方网站</div>
      </div>
    </div>

    <div style="position: relative;margin-top: 8px;">
      <!-- <div class="homeHeder">
        <img class="leftImg" @click="changleftshow" src="/static/image/home_muen.png" alt="" />
        <div class="rbox" @click="$parent.openKefu">
          <img src="/static/image/home_service.png" alt="" />
          客服
        </div>
      </div> -->
      <van-swipe @change="onChange" indicator-color="#fff" :autoplay="2000" :loop="true" :touchable="true">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.src" style="width: 100%" alt="" />
        </van-swipe-item>
        <!-- <template #indicator>
          <div class="swiper-dots">
            <div class="num">{{ current + 1 }}</div>
            <div class="sign">/</div>
            <div class="num">4</div>
          </div>
        </template> -->
      </van-swipe>
    </div>

    <!-- 公告 -->
    <div style="padding: 6px 0 0" v-if="homenoticelis.length > 0">
      <div class="gonggao">
        <img style="width: 20px" src="/static/image/icon_dt_pmd.avif" alt="" />
        <div style="flex: 1">
          <van-notice-bar color="#0a2a9b" background="#fff" scrollable
            ><span v-for="(item, index) in homenoticelis" @click="openGogao(item)" :key="index" style="font-weight: bold;font-size: 15px;">{{ item }}</span></van-notice-bar
          >
        </div>
        <img @click="$parent.goNav('/message')" style="width: 24px" src="/static/image/message.png" alt="" />
      </div>
    </div>
    <!-- 公告 -->
    <!-- -->
    <!--  -->
    <div class="domainModal_domainView__FWCzg"  v-if="goInfo" style="width:100%;max-width:412px;transform: translate(-50%, -50%);left: 50%; top: 50%; height: 100%;">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div style="position: absolute;width:100%;height: 100%;left: 0;top: 0;">
          <div class="domainModal_content" style="width:100%">

          <div class="domainModal_content__1nBgc" style="width: 92%;overflow: inherit;">
            <!-- <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" /> -->
            <img src="/static/image/close.png" @click="goInfo = null" style="position: absolute;
    width: 34px;
    height: 34px;
    transform: translate(0, -50%);
    z-index: 999;
    left: 44%;
    bottom: -60px;"/>
            <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px;border-radius: 8px;">
              {{ goInfo }}
              <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">更多公告</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jiangchi">
      <span class="num">{{ formatNumber(currentNumber)}}</span>
    </div>
    <!-- 用户信息栏 -->
    <div class="xiding">
      <div class="caosuo">
        <div class="lefsg1" v-if="$store.state.token">
          <div class="name">
            <img :src="`/static/style/vip${$store.state.userInfo.vip}.png`" alt="" class="vipji" style="width: 30px;margin-right: 6px;"/>
            <div style="margin-right: 4px;">{{ $store.state.userInfo.username }}</div> <svg width="1em" height="1em" @click="clickCopy($store.state.userInfo.username)" fill="currentColor" class="" viewBox="0 0 20.727 24">
  <path id="4e0f559826fd31bb0ad8a4c5934c2092-comm_icon_copy" d="M1801.586,16.829a1.094,1.094,0,0,1-1.1-1.093V-1.781a1.094,1.094,0,0,1,1.1-1.093,1.094,1.094,0,0,1,1.095,1.093V14.643h13.136a1.093,1.093,0,1,1,0,2.185Zm4.305-4.3a1.1,1.1,0,0,1-1.1-1.093V-6.078a1.094,1.094,0,0,1,1.1-1.093h8.759a1.094,1.094,0,0,1,.773.32l5.474,5.463a1.091,1.091,0,0,1,.321.773V11.439a1.094,1.094,0,0,1-1.1,1.093Zm1.094-2.185h12.044V1.569h-5.474A1.094,1.094,0,0,1,1812.46.476V-4.986h-5.475Z" transform="translate(-1800.491 7.171)"></path>

</svg></div>
          <div class="mey">
            <span>￥</span>{{ $store.state.userInfo.balance }}
            <img 
              src="/static/image/shuaxin.png" 
              alt="刷新" 
              class="refresh-btn" 
              @click="refreshBalance"
            />
          </div>
        </div>
        <div v-else class="lefsg" @click="$parent.goNav('/login')">
          <div class="name">未登录</div>
          <div class="mey">登录后查看</div>
        </div>
        
        <div class="riggs">
          
          <div class="lisImg" @click="$parent.openKefu">
            <img src="/static/style/icon_dt_1kf.png" alt="" />
            客服
          </div>
          <div class="lisImg" @click="$parent.goNav('/applyagent')">
            <img src="/static/style/icon_dt_1tg.png" alt="" />
            推广赚钱
          </div>
          
          <!-- <div class="lisImg" @click="$parent.goNav('/recharge')">
            <img src="/static/style/icon_dt_1cz.avif" alt="" />
            存款
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')">
            <img src="/static/style/icon_dt_1tx.avif" alt="" />
            取款
          </div> -->
          <!-- <div class="lisImg" @click="$parent.goNav('/vip')">
            <img src="/static/style/icon_dt_1vip.avif" alt="" />
            VIP
          </div> -->
          <mobile-popover placement="bottom">
            <template #trigger>
              <div class="lisImg">
                <img src="/static/style/icon_dt_1gd.png" alt="" />
                更多
              </div>
            </template>
            
            <template #content>
              <div class="popover-content">
                <div class="nei">
                  <div class="nei_list" @click="if(item.name == '官方频道'){ openFinancialService() } else{ $parent.goNav(item.url) } " v-for="(item,index) in neiList" :key="index">
                    <img :src="item.img" alt="" />
                    <span>{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </template>
          </mobile-popover>
          
        </div>
      </div>
    </div>

     <div class="container"  >
      <div class="sidebar" :class="{scrAcive: isStop}" :style="{top:isStop ? `${topHeight}px` : ''}"  ref="typeSl">
        <ul>
          <li
            v-for="(item, index) in dataList"
            :key="item.id"
            @click="scrollToSection(item.id)"
          >
          <!-- /static/image/hot1.png -->
          <img v-if="item.id === 0" :src="getImageUrl(currentIndex === index  ? '/static/image/hot2.png' : '/static/image/hot1.png')" :alt="item.name" /> 
          <img v-else :src="getImageUrl(currentIndex === index  ? item.pic_active : item.pic)" :alt="item.name" /> 
          <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="content"  ref="content" :class="{scrAciveC: isStop}">

        <div
          v-for="(item, index) in dataList"
          :key="item.id"
          :id="'section'+item.id"
          class="section"
        >
      
        
          <!-- <h2>{{ item.name }}</h2> -->
          <ul class="">
            <div class="remen" v-if="item.id === 0">
              <div class="remen_text">热门</div>
              <div class="remen_xian"></div>
              <img :src="$store.state.appInfo.site_logo" alt="">
            </div>
            <div class="rigts-title" v-if="item.id !== 0">
              <img :src="item.pic_active" alt="">
              <span>{{ item.name }}</span>
            </div>
            <template v-if="item.id === 0">
              <div class="gemini-hot-games-area-simplified">
                <div v-for="game in item.data"
                  :key="game.id"
                      class="gemini-hot-item-simplified"
                      @click="handleGameClick(game,'hot')">
                    <div class="gemini-hot-item-content-simplified">
                      <!-- 游戏图片容器 -->
                      <div class="gemini-hot-image-wrapper-simplified">
                        <img class="gemini-hot-image-simplified" :src="game.mobile_img" :alt="game.name">
                        <!-- 新游戏标记 (保留，如果需要可以再移除) -->
                        <img v-if="game.is_new === 1"
                            src="/static/image/new-tag.png"
                            alt="新"
                            class="gemini-tag-simplified gemini-tag-new-simplified">
                      </div>
                      <!-- 游戏名称 -->
                      <div class="gemini-hot-name-simplified">{{ game.name }}</div>
                    </div>
                  </div>
              </div>
            </template>
            <template v-else>  
                <li v-for="(d, i) in item.data" :key="i" @click="handleGameClick(d,'d')">
                  <img :src="d.image" alt="" class="img" >
                </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div ref="sentinel"></div>
    


    <!-- <listShuju :dataList="dataList" :isStop></listShuju> -->
    <!-- 游戏栏 -->
    <!-- <div class="gameBoxs">
      <div class="lfst">
        <div v-if="!loadingLeftSide && (!leftSideItems || leftSideItems.length === 0)" class="loading-placeholder">暂无分类</div>
        <div 
          :class="[gameType === 'hot' ? 'ls active' : 'ls']" 
          @click="changGameType('hot')"
        >
          <img :src="gameType === 'hot' ? '/static/image/hot1.png' : '/static/image/hot2.png'" alt="热门" /> 
          <span>热门</span>
        </div>
        <div v-for="item in leftSideItems"
             :key="item.id"
             :class="[gameType == item.id ? 'ls active' : 'ls']" 
             @click="changGameType(item.id,item)">
          <img :src="getImageUrl(gameType == item.id ? item.pic_active : item.pic)" :alt="item.name" /> 
          <span>{{ item.name }}</span>
        </div>
      </div>
      
      <div class="rigts game-list-container">
          <div class="rigts-title" v-if="gameType !== 'hot'">
            <img :src="clickItem.pic_active" alt="">
            <span>{{ clickItem.name }}</span>
          </div>
          <van-tabs  class="topsa"  v-if="gameType == 'hot'">
            <van-tab title="热门" :name="''"> </van-tab>
          </van-tabs>
          <div v-if="!loadingHotGames && gameType === 'hot' && hotGames.length > 0" class="hot-games-wrapper">
            <div class="gemini-hot-games-area-simplified">
              <div v-for="game in hotGames"
               :key="game.id"
                   class="gemini-hot-item-simplified"
                   @click="handleGameClick(game)">
                <div class="gemini-hot-item-content-simplified">
                  <div class="gemini-hot-image-wrapper-simplified">
                    <img class="gemini-hot-image-simplified" :src="game.mobile_img" :alt="game.name">
                    <img v-if="game.is_new === 1"
                         src="/static/image/new-tag.png"
                         alt="新"
                         class="gemini-tag-simplified gemini-tag-new-simplified">
                  </div>
                  <div class="gemini-hot-name-simplified">{{ game.name }}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="!loadingAllGames && gameType !== 'hot' && filteredGames.length > 0" class="other-games-wrapper">
            <div v-for="game in filteredGames"
                 :key="game.id"
                 class="game-card"
                 @click="handleGameClick(game)">
                
                <img class="game-card-image"
                    :src="getImageUrl(game.image)" 
                    :alt="game.name" />
          </div>
          </div>

          <div v-if="!loadingAllGames && !loadingHotGames &&
                       ((gameType === 'hot' && hotGames.length === 0) ||
                        (gameType !== 'hot' && filteredGames.length === 0))"
               class="loading-placeholder-wrapper">
             <div class="loading-placeholder">该分类下暂无游戏</div>
          </div>
      </div>
    </div> -->








    <div>
      <div class="_footerBox_a30j0_30 footer-box">
        <div class="_assembly-box_14aph_30 assembly-box">
          <div class="link-list-box _link-list-box_1gpjz_30 _verticalBox_1gpjz_55 vertical-box">
            <div class="_textlink-box_1gpjz_35 textlink-box" data-columns="3">
              <div class="_item-box_1gpjz_35 textlink-item">
                <div class="_title_1gpjz_35 link-list-title">娱乐城</div>
                <div class="_item-list_1gpjz_40 item-list">
                  <div class="_item_1gpjz_35 link-list-item">任务</div>
                  <div class="_item_1gpjz_35 link-list-item">待领取</div>
                  <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/vip')">VIP</div>
                  <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/fanshui')">推广赚钱</div>
                  <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/activity')">活动</div>
                  <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/fanshui')">返水</div>
                </div>
              </div>
              <div class="_item-box_1gpjz_35 textlink-item">
                <div class="_title_1gpjz_35 link-list-title">游戏</div>
                <div class="_item-list_1gpjz_40 item-list">
                  <div class="_item_1gpjz_35 link-list-item">热门</div>
                  <div class="_item_1gpjz_35 link-list-item">体育</div>
                  <div class="_item_1gpjz_35 link-list-item">真人</div>
                  <div class="_item_1gpjz_35 link-list-item">棋牌</div>
                  <div class="_item_1gpjz_35 link-list-item">电竞</div>
                  <div class="_item_1gpjz_35 link-list-item">彩票</div>
                  <div class="_item_1gpjz_35 link-list-item">电子</div>
                  <div class="_item_1gpjz_35 link-list-item">娱乐</div>
                </div>
              </div>
              <div class="_item-box_1gpjz_35 textlink-item">
                <div class="_title_1gpjz_35 link-list-title">支持</div>
                <div class="_item-list_1gpjz_40 item-list">
                  <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/kefu')">在线客服</div>
                  <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/kefu')">帮助中心</div>
                  <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/boutBallBet')">有奖反馈</div>
                </div>
              </div>
            </div>
            <div class="_license-compliance_ablfx_30 license-compliance">
              <div class="_title_ablfx_30">牌照合规</div>
              <div class="_license-compliance-list_ablfx_35">
                <!----><img
                  class="lobby-image lobby-image"
                  data-load-strategy="loading-set@1:lazy@0"
                  data-status="success"
                  data-thumb="0"
                  data-id="ffc51a28-1ad4-4664-b74c-d8a49384c2d1"
                  src="https://xd55.vip/siteadmin/skin/lobby_asset/common/common/common/18plus.avif?manualVersion=1&amp;version=10fea753dc"
                  alt="."
                  style="width:37px; height:37px;"
                /><!---->
              </div>
            </div>
          </div>
          <div class="_channel-box_1tgxg_30 channel-box">
            <span class="_title_1tgxg_36" @click="openFinancialService">官方频道</span>
            <div class="_channel-items_1tgxg_42 channel-items">
              <div class="_channel-item_1tgxg_42 channel-item">
                <img class="lobby-image lobby-image" data-load-strategy="loading-set@1:lazy@0" data-status="success" data-thumb="0" 
                data-id="f927e4b8-ef27-46a2-88b7-77834a1bdec7" src="https://xd22.vip/siteadmin/officialcommunity/img_gfpd_telegram.png" alt="." 
                style="width:28px; height: 28px;" />
              </div>
            </div>
          </div>
          <div class="ui-placeholder ui-placeholder--container _contactus-box_18kto_43 contactus-box">
            <!---->
            <div>
              <div class="_contact-us-title_18kto_54 contact-us-title" @click="openFinancialService">联系我们</div>
              <div class="_contactUs_18kto_30 contact-us">
                <div class="_socialItem_18kto_36">
                  <img class="lobby-image lobby-image" data-load-strategy="loading-set@1:lazy@0" 
                  data-status="success" data-thumb="0" data-id="3184a6ad-aa5c-4a17-be7a-363c8e24abf3" 
                  src="https://xd55.vip/siteadmin/upload/img/telegram.avif" alt="开云娱乐客服" style="width: 28px; height:28px;" />
                </div>
                <!---->
              </div>
            </div>
          </div>
          <div class="_mixin-text_1yte4_30 footer-mixin-text">
            <div class="">
              <div>
                <div style="text-align: center; font-size: 0.24rem; line-height: 1.6; color: #666666;">
                  <p>
                    开云娱乐是国际最知名的线上博彩运营公司，为大家提供刺激好玩的真人荷官娱乐城、棋牌、电子、捕鱼、彩票、体育等全品类游戏；千万资金秒下分，上下分无忧；24小时客服Telegram账号<span style="color: #e03e2d;">
                      <strong
                        ><span style="background-color: #ffffff;"
                          ><a style="color: #e03e2d; background-color: #ffffff;" href="https://t.me/xdvip" target="_blank" data-jump="1"><span style="color: #008000;">@xdvip</span></a></span
                        ></strong
                      ></span
                    >
                  </p>
                </div>
                <div style="text-align: center;">
                  <a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898028847159623681.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028847159623681.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898028876860772353.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028876860772353.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898028918005776386.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028918005776386.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898028941653094402.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028941653094402.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898028962747535362.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028962747535362.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898028983284523009.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028983284523009.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"
                  /></a>
                </div>
                <div style="text-align: center;">
                  <a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898029702228766722.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898029702228766722.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898030460586737666.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898030460586737666.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898030547513786370.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898030547513786370.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                  ><a target="_blank" data-jump="1"
                    ><img
                      style="margin-right: 4px; margin-bottom:8px; max-width: 100%; opacity: 1; width: 40px;"
                      src="https://xd55.vip/siteadmin/upload/img/1898030596835790849.png"
                      onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898030596835790849.png';"
                      onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"
                  /></a>
                </div>
                <div style="display: flex; align-items: center; justify-content: center; font-size: 0.18rem; color: #55657e; text-align: center;">
                  <div style="width: calc((100% - 0.11rem) / 2); padding: 0 0.15rem; white-space: normal; word-break: break-all; text-align: center; color: #999999; ;width: calc((100% - 0.11rem) / 2);">
                    <p>本站面向海外用户，只支持美金和USDT充值，不支持人民币充值，请中国用户不要违法赌博。</p>
                  </div>
                  <div style="display: inline-block; height: 1em; margin: 0 0.05rem; position: relative; vertical-align: middle; width: 0.01rem; background: #E3E3E3;">&nbsp;</div>
                  <div style="width: calc((100% - 0.11rem) / 2); padding: 0 0.15rem; white-space: normal; word-break: break-all; text-align: center; color: #999999; ;width: calc((100% - 0.11rem) / 2);">
                    <p>@开云娱乐版权所有 2002-2025</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>





    <!-- <indexBo></indexBo> -->

    <div class="fixedDiv">
      <div class="kefu" v-if="kefuShow">
        <img src="/static/image/ActiveImg14434788393575025.webp" alt="" class="tg" @click="openFinancialService">
        <img src="/static/image/comm_icon_gb.avif" alt="" class="tgClose" @click="kefuShow = false">
      </div>
      <!--<div class="kefu1" v-if="appShow">
        <img src="/static/image/ActiveImg7121672414880103.webp" alt="" class="tg" @click="$parent.goNav('/app')">
        <img src="/static/image/comm_icon_gb.avif" alt="" class="tgClose" @click="appShow = false">
      </div> -->
      <div class="ding" @click="scrollToTop" v-show="showBackToTop"> 
        <div class="_iconWrap_1q2kk_44">
          <i class="lobby-image lobby-image lobby-image--skeleton" data-load-strategy="loading-set@0:lazy@0" data-status="success" data-thumb="0"  data-id="d275534c-e1a5-4e8c-89bb-84875c620c96" data-src="/siteadmin/skin/lobby_asset/common/web/common/comm_icon_fhdb.svg" 
          style="display: inline-flex; justify-content: center; align-items: center;">
          <svg width="12px" height="12px" fill="#fff" class="" viewBox="0 0 12.389 19.945">
            <path id="0d7322b3273dc8daf00c7dc9c60b11f5-comm_icon_fhdb" d="M37.695,23h12c.13,0,.195.13.195.26s-.065.547-.195.547h-12c-.13,0-.195-.417-.195-.547S37.565,23,37.695,23Zm6,2.924A8.169,8.169,0,0,1,47.982,33.2a2.923,2.923,0,0,1,1.429,3.118,3.05,3.05,0,0,1-2.339,2.664c-.65-.065-.455-.52-.455-.52l-.195-.845s-.91,1.364-1.169,1.364H42.005c-.26,0-1.169-1.364-1.169-1.364l-.195.845s.13.455-.455.52a3.05,3.05,0,0,1-2.339-2.664A3.188,3.188,0,0,1,39.406,33.2,8.408,8.408,0,0,1,43.694,25.924ZM41.94,31.316a1.755,1.755,0,1,0,3.508,0,1.755,1.755,0,1,0-3.508,0Zm.455,10.72a.375.375,0,0,0,.39-.39V39.827a.39.39,0,1,0-.78,0v1.819A.374.374,0,0,0,42.4,42.036Zm1.364.91a.419.419,0,0,0,.39-.39V39.892a.39.39,0,0,0-.78,0v2.664A.419.419,0,0,0,43.759,42.945Zm1.234-1.364a.374.374,0,0,0,.39-.39v-1.3a.39.39,0,0,0-.78,0v1.3A.374.374,0,0,0,44.994,41.581Z" transform="translate(-37.5 -23)" fill-rule="evenodd"></path>
          </svg></i>
        </div>
        <p class="dingtext">顶部</p>
      </div>
    </div>
    <!-- 弹出层 -->
    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>Hi，欢迎进入{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">专属VIP体验</div>
            <p>立享会员特权</p>
            <p>享受只属于你的与众不同</p>
            <dd @click="$parent.goNav('/vip')">会员中心</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />消息中心<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />意见反馈<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />永久域名<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />关于我们<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">立即登录</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />安全退出</div>
        </div>
      </div>
    </van-popup>

    <!-- 官网弹窗 -->
    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow" style="width:100%;max-width:412px;transform: translate(-50%, -50%);left: 50%; top: 50%; height: 100%;">
        <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
        <div style="position: absolute;width:100%;height: 100%;left: 0;top: 0;">
          <div class="domainModal_content" style="width: 92%">
          <img src="/static/image/close.png" @click="changtanshow" class="closeDom"/>

            <div class="domainModal_content__1nBgc" style="width: 92%;background: #866638;">
              <div id="domain" class="domainModal_contentTop__2C4jc" style="background: inherit!important;">

                <div class="domainModal_top__1omYS" style="height: 32px;line-height: 32px;font-size: 12px;">欢迎来到{{ $store.state.appInfo.title }}</div>
                <div class="domainModal_middle__3gQPm" style="color: #666;padding: 10px 20px;" v-html="$store.state.appInfo.webcontent"></div>
              </div>
            </div>
          </div>
        </div>
    </div>



    <!-- APP下载弹窗已移除 -->
    <!-- <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && downAppshow" style="width:100%;max-width:412px;transform: translate(-50%, -50%);left: 50%; top: 50%; height: 100%;">
        <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="downAppshow = false"></div>
        <div style="position: absolute;width:100%;height: 100%;left: 0;top: 0;">
          <div class="domainModal_content" style="width: 100%;position: absolute;">
          <img src="/static/image/close.png" @click="guantan" class="closeDom"/>

            <div class="domainModal_content__1nBgc" style="width: 92%;background: #866638;">
              <div id="domain" class="domainModal_contentTop__2C4jc" style="background: inherit!important;">
                <div class="domainModal_middle__3gQPm" style="color: #666;padding: 10px 6px;">
                  <div class="downApp">
                    <img :src="$store.state.appInfo.site_logo" alt="">
                    <div class="downAppText">
                      <p class="text1">下载APP申请58U体验金</p>
                      <p class="text2">首存多少送多少</p>
                      <p class="text3">电子每日首存加赠<span>10%</span></p>
                      <p class="text4">笔笔充值笔笔再送<span>2%</span></p>
                    </div>
                  </div>
                  <div class="downbtn">
                    <div class="downbtn_left">极速APP(5.8M)</div>
                    <div class="downbtn_right" @click="$parent.goNav('/gamePage?app=1')">原生APP(76.8M)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div> -->
  </div>
</template>
<script>
import apiFun from "@/http/api.js";
import MobilePopover from './MobilePopover.vue'
import indexBo from './indexBo.vue'
import listShuju from './list.vue'
export default {
 components: {
    MobilePopover,indexBo,listShuju
  },
  name: 'index',
  data() {
    return {
      topHeight:0,
      currentIndex: 0,
      isStop:false,
      dataList:[],
      showBackToTop: false,
      neiList:[
        {
          name:'APP下载',
          img:'/static/style/icon_dt_1app.avif',
          url:'/app'
        },
        {
          name:'充值',
          img:'/static/style/icon_dt_1cz.avif',
          url:'/recharge'
        },
        {
          name:'提现',
          img:'/static/style/icon_dt_1tx.avif',
          url:'/withdrawal'
        },
        {
          name:'活动',
          img:'/static/style/icon_dt_1yh.avif',
          url:'/activity'
        },
        {
          name:'返水',
          img:'/static/style/icon_dt_1fs.avif',
          url:'/fanshui'
        },
        {
          name:'个人资料',
          img:'/static/style/icon_dt_1sz.avif',
          url:'/userInfo'
        },
        {
          name:'安全中心',
          img:'/static/style/icon_dt_1aqzx.avif',
          url:'/userCent'
        },
        {
          name:'账户明细',
          img:'/static/style/icon_dt_1zhmx.avif',
          url:'/money'
        },
        {
          name:'投注记录',
          img:'/static/style/icon_dt_1tzjl.avif',
          url:'/betRecord'
        },
        {
          name:'提现管理',
          img:'/static/style/icon_dt_1txgl.avif',
          url:'/wallet'
        },
        {
          name:'VIP',
          img:'/static/style/icon_dt_1vip.avif',
          url:'/vip'
        },

        {
          name:'赞助',
          img:'/static/style/icon_dt_1yeb.avif',
          url:'/zhanzhu'
        },
        {
          name:'有奖反馈',
          img:'/static/style/icon_dt_1yjfq.avif',
          url:'/boutBallBetInfo?type=4'
        },
        {
          name:'消息中心',
          img:'/static/style/icon_dt_1grbb.avif',
          url:'/message'
        },
        {
          name:'待领取',
          img:'/static/style/icon_dt_1jl.avif',
          url:'/fanshui'
        },
        {
          name:'投注任务',
          img:'/static/style/icon_dt_1jh.avif',
          url:'/betRecord'
        },
        {
          name:'交易记录',
          img:'/static/style/icon_dt_1lqjl.avif',
          url:'/transRecord'
        },
        {
          name:'官方频道',
          img:'/static/style/img_gfpd_telegram.png',
          url:'/'
        },
      ],
      currentNumber: 0,
      hongbashow: true,
      appshow: false,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      gameType: 0,
      tanshow: false,
      goInfo: null,
      
      // New state for left sidebar
      leftSideItems: [],
      loadingLeftSide: false,
      
      // New state for right side games
      allGames: [], 
      loadingAllGames: false,
      
      // 热门游戏专用数据
      hotGames: [],
      loadingHotGames: false,
      kefuShow:true,
      appShow:true,
      financialServiceUrl: null,
      downAppshow:false,
      clickItem:{
        name:'',
        pic_active:''
      }
    };
  },
  computed: {
    // Filters the games based on the category selected on the left
    filteredGames() {
       console.log(`Filtering games. Current gameType (category ID): ${this.gameType}`);
       if ((!this.gameType && this.gameType !== 'hot') || !this.allGames || this.allGames.length === 0) {
         console.log('No gameType selected or allGames is empty. Returning empty array.');
         return [];
       }
       
       // 热门游戏由单独的接口获取，不再在这里筛选
       if (this.gameType === 'hot') {
         return this.hotGames;
       }
       
       console.log(`Filtering ${this.allGames.length} total games.`);
       
       // Filter allGames where the game's type matches the selected gameType (category ID)
       const result = this.allGames.filter(game => {
         return game.type === this.gameType;
       });
       
       console.log(`Filtering result count: ${result.length}`);
       console.log(result,'6666');
       
       return result;
    }
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
    
    // 默认选择热门游戏
    this.gameType = 'hot';
    
    that.fetchLeftSideItems(); // Fetch data for the left sidebar
    // that.fetchAllGames();      // Fetch ALL games for right side filtering
    // that.fetchHotGames();      // Fetch hot games separately
    // 所有用户都获取客服链接
    this.fetchServiceUrl();



    this.initRandomNumber()
    
    // 立即开始数字动画
    this.startNumberAnimation()
  },
  
  methods: {
    scrollToTop(){
      window.scrollTo({
        top: 0,
        behavior: "smooth" // 启用平滑滚动
      });
    },
    formatNumber(num) {
      
      return num.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    initRandomNumber() {
      // 尝试从本地存储获取上次的数字
      const lastNumber = localStorage.getItem('lastNumber') 
      
      if (lastNumber && lastNumber > 0) {
        // 如果有上次的数字，在其基础上小幅变化（±50万以内）
        const maxChange = 500000 // 50万
        const randomChange = (Math.random() - 0.5) * 2 * maxChange

        const newValue = Number(lastNumber) + randomChange
        
        // 确保在合理范围内
        const min = 711683290.88
        const max = 961683290.88
        this.currentNumber = Math.max(min, Math.min(max, newValue))
        
      } else {
        // 如果没有历史数据，在711683290.88到961683290.88之间随机生成初始值
        const min = 711683290.88
        const max = 961683290.88
        const randomValue = Math.random() * (max - min) + min
        this.currentNumber = randomValue
      }
      
      this.targetNumber = this.currentNumber
      // 保存当前数字到本地存储
      localStorage.setItem('lastNumber', this.currentNumber)
    },
    startNumberAnimation() {
      
      // 第一次变化在500ms后开始
      setTimeout(() => {
        this.triggerNumberChange()
      }, 1000)
      
      // 之后每3秒随机变化数字
      this.numberTimer = setInterval(() => {
        this.triggerNumberChange()
      }, 3000)
    },
    triggerNumberChange() {
      // 生成随机变化幅度（限制在100万以内）
      const maxChange = 1000000 // 100万
      const randomChange = (Math.random() - 0.5) * 2 * maxChange
      this.targetNumber = Math.max(0, this.currentNumber + randomChange)
      
      // 平滑过渡到目标数字
      this.animateToTarget()
    },
    animateToTarget() {
      const startNumber = this.currentNumber
      const endNumber = this.targetNumber
      const duration = 1500 // 1.5秒过渡时间
      const startTime = Date.now()
      
      const animate = () => {
        const elapsed = Date.now() - startTime
        const progress = Math.min(elapsed / duration, 1)
        
        // 使用缓动函数
        const easeProgress = 1 - Math.pow(1 - progress, 3)
        
        this.currentNumber = startNumber + (endNumber - startNumber) * easeProgress
        
        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          this.currentNumber = endNumber
          // 保存最新数字到本地存储
          localStorage.setItem('lastNumber', this.currentNumber)
        }
      }
      
      requestAnimationFrame(animate)
    },


    async fetchServiceUrl() {
      try {
        const res = await this.$apiFun.post('/api/getservicerurl', {});
        if (res.code === 200 && res.data) {
          this.onlineServiceUrl = res.data.kf_url || null;
          this.financialServiceUrl = res.data.cwkf_url || null;
          console.log("Fetched service URLs:", { online: this.onlineServiceUrl, financial: this.financialServiceUrl });
        } else {
          console.error("Failed to fetch service URLs:", res.message || 'URLs not found in response');
          if (this.$parent && typeof this.$parent.showTost === 'function') {
            this.$parent.showTost(0, res.message || '获取客服链接失败');
          }
        }
      } catch (error) {
        console.error("Error fetching service URLs:", error);
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(0, '获取客服链接时出错');
        }
      }
    },
     openFinancialService() {
      if (this.financialServiceUrl) {
        console.log("Opening financial service in new window:", this.financialServiceUrl);
        window.open(this.financialServiceUrl, '_blank');
      } else {
        console.error("Financial Service URL not available.");
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(0, '飞机客服链接不可用，请稍后重试');
        }
      }
    },
    guantan(){
      // APP下载弹窗已被移除，此方法保留以防调用
      this.downAppshow = false;
    },
    clickCopy(text){
      let that = this
      // 创建临时的textarea
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      // 选中文本
      textArea.focus();
      textArea.select();

      try {

      // 尝试执行复制

      const successful = document.execCommand('copy');

      const msg = successful ? '成功复制到剪贴板！' : '复制失败，请手动复制！';

        that.showTost(2, msg);

      } catch (err) {

        that.showTost(2, 123);

      }

      // 移除临时元素

      document.body.removeChild(textArea);

    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    openGogao(val) {
      this.goInfo = val;
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(typeId,item) {
      console.log(item);
      this.clickItem = item
      console.log(`changGameType called with typeId: ${typeId} (Type: ${typeof typeId})`);
      
      // 处理热门游戏的特殊情况
      if (typeId === 'hot') {
        this.gameType = 'hot';
        console.log(`gameType updated to: hot (Type: string)`);
        // 如果热门游戏数据为空，则加载热门游戏
        if (this.hotGames.length === 0 && !this.loadingHotGames) {
          this.fetchHotGames();
        }
        return;
      }
      
      // 正常处理数字类型的游戏类型ID
      const numericTypeId = Number(typeId); 
      if (!isNaN(numericTypeId)) {
          this.gameType = numericTypeId;
          console.log(`gameType updated to: ${this.gameType} (Type: ${typeof this.gameType})`);
      } else {
          console.error("Invalid typeId received:", typeId);
      }
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$parent.showTost(1, '复制成功！');
      document.body.removeChild(cInput);
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
        })
        .catch(res => {
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    async fetchLeftSideItems() {

      let that = this
      that.fetchHotGames(); 
       try {
         const res = await apiFun.post('/api/getGameType'); 
         if (res && res.code === 200 && Array.isArray(res.data)) {
           this.leftSideItems = res.data.filter(item => item.status === 1);
           that.fetchAllGames();      // Fetch ALL games for right side filtering
           
           if (this.leftSideItems.length > 0 && this.gameType === 0) { 
             // Use $nextTick to ensure computed property recalculates after gameType is set
             this.$nextTick(() => { 
                // Ensure we set it as a number
                const initialTypeId = Number(this.leftSideItems[0].id);
                if (!isNaN(initialTypeId)){
                    this.gameType = initialTypeId; 
                    console.log("Initial gameType set to:", this.gameType);
                } else {
                    console.error("Invalid initial typeId:", this.leftSideItems[0].id);
                }
             });

           }
         } else {
           console.error("Failed to fetch left side items:", res);
           this.leftSideItems = [];
         }
       } catch (error) {
         console.error("Error fetching left side items:", error);
         this.leftSideItems = [];
       }
     },
     async fetchAllGames() {
       try {
         const res = await apiFun.post('/api/getGameTypeList', {}); 
         if (res && res.code === 200 && Array.isArray(res.data)) {
           this.allGames = res.data.filter(game => game.status === 1);
           console.log(`Fetched ${this.allGames.length} active games for filtering:`, this.allGames.map(g => ({id: g.id, name: g.name, type: g.type}))); 
         } else {
           console.error("Failed to fetch all games from /api/getGameTypeList:", res);
           this.allGames = []; 
         }
       } catch (error) {
         console.error("Error fetching all games from /api/getGameTypeList:", error);
         this.allGames = []; 
       }
       console.log(this.allGames,'2222222222222222');
       console.log(this.leftSideItems,6333);
       let arr = this.leftSideItems.map(x =>{
        const result = this.allGames.filter(game => {
          return game.type === x.id;
        })
        return{
          ...x,
          data:result
        }
       })
       arr.unshift({id:0,name:'热门',data:this.hotGames})
       this.dataList = arr
       
      //  this.allGames.forEach(item =>{
      //   this.leftSideItems.forEach(x =>{
      //     if(item.type == x.id){
      //       let obj = Object.assign({},x,{
      //         data:item
      //       })
      //       arr.push(obj)
      //     }
      //   })
      //  })
      
       
             
       
     },
     async fetchHotGames() {
       try {
         // 调用接口获取热门游戏数据
         const res = await apiFun.post('/api/game/list', { is_hot: 1 });
         if (res && res.code === 200 && Array.isArray(res.data)) {
           this.hotGames = res.data.filter(game => game.app_state === 1);
           console.log(`获取到${this.hotGames.length}个热门游戏`);
         } else {
           console.error("获取热门游戏失败:", res);
           this.hotGames = [];
         }
       } catch (error) {
         console.error("获取热门游戏异常:", error);
         this.hotGames = [];
       }
     },
     getImageUrl(relativePath) {
        if (!relativePath || typeof relativePath !== 'string') return '';
        if (relativePath.startsWith('http') || relativePath.startsWith('data:')) { return relativePath; }
        if (relativePath.startsWith('/static/')) { return relativePath; }
        return '/storage/' + relativePath.replace(/^\/+/, ''); 
    },
    handleGameClick(game,type) {
      console.log(3333333333333333333);
      
      console.log('点击游戏:', game);

      const requiresListPage = game.single === 2 || game.single === '2';

      if (requiresListPage) {
        console.log('游戏需要跳转到列表页');
        let pathId, platformParam, gameTypeListIdParam, gameCodeParam;

        if (type === 'hot') {
          // --- 热门游戏处理 (跳转列表) ---
          pathId = game.game_type_id || '13';
          platformParam = game.platform_name || 'pg';
          gameTypeListIdParam = game.game_type_id || '13';
          gameCodeParam = game.game_code || 'null';
        } else {
          // --- 普通游戏分类处理 (跳转列表) ---
          pathId = game.id || '13'; // game.id is game_type_list.id here
          platformParam = game.platform || 'pg';
          gameTypeListIdParam = game.id || '13'; // game.id is game_type_list.id here
          gameCodeParam = 'null';
        }
        this.$parent.goNav(`/gameTypeList/${pathId}?platform=${platformParam}&game_type_list_id=${gameTypeListIdParam}&game_code=${gameCodeParam}`);

      } else {
        // --- 直接打开游戏 (single !== 2) ---
        console.log('直接打开游戏');
        let gameIdToOpen;
        let gameCodeToOpen = ''; // 默认为空字符串

        if (type === 'hot') {
          // 对于热门游戏，继续使用 game_type_id 和 game_code
          gameIdToOpen = game.game_type_id;
          gameCodeToOpen = game.game_code || '';
          console.log(`[热门] 调用 openGamePage: ID=${gameIdToOpen}, Code=${gameCodeToOpen}`);
        } else {
          // 对于非热门游戏 (来自 /api/getGameTypeList) 且 single !== 2:
          // 使用 game.id (即 game_type_list.id) 作为 ID
          // 传递空字符串作为 game_code
          gameIdToOpen = game.id; // 使用列表项 ID
          gameCodeToOpen = '';   // game_code 设为空
          console.log(`[非热门/直接打开] 调用 openGamePage: ListItemID=${gameIdToOpen} (来自 game.id), Code=${gameCodeToOpen}`);
        }

        // 确保 gameIdToOpen 有效再调用
        if (typeof gameIdToOpen !== 'undefined' && gameIdToOpen !== null) {
             this.$parent.openGamePage(game.name, gameIdToOpen, gameCodeToOpen);
        } else {
             console.error("无法确定有效的 gameIdToOpen 来调用 openGamePage", game);
             this.$parent.showTost(0, '打开游戏失败，参数错误'); // 给用户一个提示
        }
      }
    },
    async refreshBalance() {
      try {
        this.$parent.showLoading && this.$parent.showLoading();
        const res = await this.$apiFun.post('/api/balance', {});
        if (res.code === 200) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'));
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.$store.commit('changUserInfo');
        } else {
          this.$parent.showTost && this.$parent.showTost(0, res.message || '刷新失败');
        }
      } catch (e) {
        this.$parent.showTost && this.$parent.showTost(0, '网络错误');
      } finally {
        this.$parent.hideLoading && this.$parent.hideLoading();
      }
    },
    scrollToSection(categoryId){
          const topHeight1 = this.$refs.topHeight;
          this.topHeight = topHeight1.getBoundingClientRect().height
          this.activeCategory = categoryId;
          const targetElement = document.getElementById('section' + categoryId);
          
          if (targetElement) {
            // 计算滚动位置（减去顶部导航高度）
            // const headerHeight = document.querySelector('header').offsetHeight;
            const targetPosition = targetElement.offsetTop - this.topHeight;
            
            // 平滑滚动到目标位置
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }


        // const section = this.$refs['section' + index][0]
        // console.log(section);
        
        // if (section) {
        //   window.scrollTo({
        //       top: section.getBoundingClientRect().top,
        //       behavior: 'smooth'
        //   });
        // }
    },
    handleScroll() {
       const topHeight1 = this.$refs.topHeight;
       this.topHeight = topHeight1.getBoundingClientRect().height + 10
       console.log(this.topHeight);
       
      let that = this
      const sentinel = this.$refs.sentinel;
      const sentinel1 = this.$refs.typeSl;
 
        
      
      if(sentinel.getBoundingClientRect().top <= Number(this.topHeight) + Number(358)){
        this.$nextTick(() =>{
          that.isStop = false
        })
        
      }
      // 获取当前滚动位置
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      // 判断是否在页面顶部（>1px 即显示按钮）
      this.showBackToTop = scrollPosition > 1;
      if(scrollPosition>=365) {
        this.isStop = true
      }else{
        this.isStop = false
      }  
    },
  },
  mounted() {
    let that = this;
    window.addEventListener('scroll', this.handleScroll);
    
    // 延迟显示官网欢迎弹窗，确保appInfo已加载
    setTimeout(() => {
      if (that.$store.state.appInfo.index_modal == 1) {
        that.tanshow = true;
      }
    }, 500);
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
     window.removeEventListener('scroll', this.handleScroll);
  },
  
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';
.domainModal_content__1nBgc {
  overflow: hidden;
}
.domainModal_content{
    width: 80%;
    z-index: 1001;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
}
// 轮播样式
.swiper-dots {
  display: flex;
  position: absolute;
  left: 40px;
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABkCAYAAADDhn8LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTk4MzlBNjE0NjU1MTFFOUExNjRFQ0I3RTQ0NEExQjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTk4MzlBNjA0NjU1MTFFOUExNjRFQ0I3RTQ0NEExQjMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Q0E3RUNERkE0NjExMTFFOTg5NzI4MTM2Rjg0OUQwOEUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Q0E3RUNERkI0NjExMTFFOTg5NzI4MTM2Rjg0OUQwOEUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Gh5BPAAACTUlEQVR42uzcQW7jQAwFUdN306l1uWwNww5kqdsmm6/2MwtVCp8CosQtP9vg/2+/gY+DRAMBgqnjIp2PaCxCLLldpPARRIiFj1yBbMV+cHZh9PURRLQNhY8kgWyL/WDtwujjI8hoE8rKLqb5CDJaRMJHokC6yKgSCR9JAukmokIknCQJpLOIrJFwMsBJELFcKHwM9BFkLBMKFxNcBCHlQ+FhoocgpVwwnv0Xn30QBJGMC0QcaBVJiAMiec/dcwKuL4j1QMsVCXFAJE4s4NQA3K/8Y6DzO4g40P7UcmIBJxbEesCKWBDg8wWxHrAiFgT4fEGsB/CwIhYE+AeBAAdPLOcV8HRmWRDAiQVcO7GcV8CLM8uCAE4sYMyJ5cwCHs4rCwI4sYBxJ5YzC84rCwKcXxArAuthQYDzC2JF0H49LAhwYUGsCFqvx5EF2T07dMaJBetx4cRyaqFtHJ8EIhK0i8OJBQxcECuCVutxJhCRoE0cZwMRyRcFefa/ffZBVPogePihhyCnbBhcfMFFEFM+DD4m+ghSlgmDkwlOgpAl4+BkkJMgZdk4+EgaSCcpVX7bmY9kgXQQU+1TgE0c+QJZUUz1b2T4SBbIKmJW+3iMj2SBVBWz+leVfCQLpIqYbp8b85EskIxyfIOfK5Sf+wiCRJEsllQ+oqEkQfBxmD8BBgA5hVjXyrBNUQAAAABJRU5ErkJggg==);
  background-size: 100% 100%;
}
.swiper-dots .num {
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.swiper-dots .sign {
  position: absolute;
  top: 0;
  left: 50%;
  line-height: 24px;
  font-size: 8px;
  color: #fff;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
// 主页头部标题

.homeHeder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  box-sizing: border-box;
  padding: 0 30px;
  z-index: 999;
  align-items: center;
  justify-content: space-between;
  .leftImg {
    width: 19px;
    height: 19px;
  }
  .rbox {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, sans-serif;
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #866638;
  color: #866638;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #e6ebf6;
      color: #4e6693;
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #dfe5ff;
    border-radius: 0.4rem;
    border: 0;
    color: #4e6693;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}
.gonggao {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #666666;
  width: 94%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    // flex: 1;
    display: flex;
    align-items: center;
    .name {
      font-size: 12px;
      border: 1px solid  #866638;
      padding: 6px 10px;
      border-radius:5px;
      color: #866638;
    }
    .mey {
      margin-left: 10px;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      font-size: 12px;
      border: 1px solid  #866638;
      padding: 6px 10px;
      border-radius:5px;
      color: #fff;
      background: #866638;
      
    }
    .mey span {
      font-size: 10px;
      font-weight: 400;
    }
  }
  .lefsg1 {
    // flex: 1;
    // display: flex;
    // align-items: center;
    .name {
      font-size: 12px;
      // border: 1px solid  #866638;  
      padding: 6px 10px;
      border-radius:5px;
      color: #866638;
      display: flex;
      align-items: center;
    }
    .mey {
      margin-left: 10px;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      font-size: 12px;
      border: 1px solid  #eee;
      padding: 2px 2px;
      border-radius:10px;
      color: #ffaa09;
      display: inline-block;
      // background: #866638;
    }
    .mey span {
      font-size: 10px;
      font-weight: 400;
    }
    .refresh-btn{
      width: 10px;
      height: 10px;
    }
  }
  .riggs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .lisImg {
      width: 56px;
      text-align: center;
      font-size: 12px;
      img {
        width: 60%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
.xiding {
  background-color: #fff;
  padding: 6px 0;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  z-index: 10;
}

// 游戏
.gameBoxs {
  background: #fff;
  // -webkit-box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  // box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  box-sizing: border-box;
  padding: 0 10px;
  color: #866638;
  height: auto;
  // margin-bottom: 50px;
  // padding-bottom: 60px;
  display: flex;
  justify-content: space-between;
  .lfst {
    width: 80px;
    // background: #eff3ff;
    // border-radius: 20px;
    border: 1px solid #fff;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    // justify-content: flex-start;
    // flex-shrink: 0;
    // align-self: flex-start;
    .ls.active {
      color: #fff;
      background: #866638;
    }
    .ls {
      text-align: center;
      border-radius: 4px;
      padding: 4px 10px;
      box-sizing: border-box;
      margin-bottom: 10px;
      // min-height: 60px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // background: #f5f0e294;
      background: url('/static/image/btn_zc1_2.avif') no-repeat center center;
      background-size: 100%;
      width: 78px;
      height: 36px;
      // justify-content: center;
      color: #666;
      img {
        width: 30px;
        height: 25px;
        display: block;
        // margin: 0 auto;
      }
      span {
        font-size: 10px;
        display: block;
        margin-top: 3px;
        // color: #666;
      }
    }
  }
  .rigts {
    flex: 1;
    box-sizing: border-box;
  }
}
.appTop{
  position: sticky;
    right: 0;
    top: 0;
    z-index: 12;
}
// app下载
.appbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // height: 1rem;
  box-sizing: border-box;
  padding-top: 4px;
  padding-right: 15px;
  .colse {
    width:16px;
    margin: 0 8px 0 16px;
  }
  .logo {
    width: 40px;
    margin: 0 0.2rem;
  }
  .testz {
    flex: 1;
    .tit {
      font-size: 14px;
      font-weight: bold;
      color: #0a2a9b;
    }
    .cx {
      font-size: 12px;
      font-weight: bold;
      color: #866638;
    }
  }
}
.appbox1 {
  display: flex;
  align-items: center;
  // height: 1rem;
  box-sizing: border-box;
  padding-right: 15px;
  border-bottom: 1px solid #e5e5e5;
  margin: 4px 0 4px 0;
  padding-bottom: 4px;
  .logo {
    width: 54px;
    margin: 0 8px 0 4px;
  }
  .testz1 {
    flex: 1;
    .tit {
      font-size: 18px;
      font-weight: bold;
      color: #866638;
    }
    .cx {
      font-size: 16px;
      font-weight: bold;
      color: #0a2a9b;
    }
  }
}
.loading-placeholder {
  text-align: center;
  padding: 20px;
  color: #999;
  width: 100%;
}

/* 热门游戏区域 - 简化 */
.gemini-hot-games-area-simplified {
  display: flex;
  flex-wrap: wrap;
  background: transparent;
  padding: 5px;
  box-sizing: border-box;
}

.gemini-hot-item-simplified {
  width: 33.33%;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.gemini-hot-item-content-simplified {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  margin: 0 auto;
}

.gemini-hot-image-wrapper-simplified {
  position: relative; /* 用于定位新标签 */
  width: 100%;
  padding-top: 100%; /* 关键：强制容器高度等于宽度，形成正方形 */
  border-radius: 12px; /* 保留圆角 */
  overflow: hidden;
}

.gemini-hot-image-simplified {
  position: absolute; /* 让图片填充绝对定位的容器 */
  top: 0;
  left: 0;
  width: 100%; /* 图片宽度占满容器 */
  height: 100%;     /* 图片高度也占满容器 */
  display: block;
  object-fit: cover; /* 关键：图片覆盖整个容器，保持比例，多余部分裁剪 */
  border-radius: 12px; /* 给图片本身也加上圆角 */
}

.gemini-tag-simplified {
  position: absolute;
  z-index: 2;
}

/* 新游戏标记 */
.gemini-tag-new-simplified {
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
}

.gemini-hot-name-simplified {
  font-size: 12px;
  color: #555;
  margin-top: 6px;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 移除其他 gemini- 开头的旧样式 */

/* 热门标记 */
.hot-tag {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  z-index: 2;
}

.hot-tag img {
  width: 100%;
  height: 100%;
}

/* 平台标识 */
.platform-tag {
  position: absolute;
  bottom: 30px;
  right: 5px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
}

/* Game Section Layout */
.gameBoxs {
  display: flex;
  // Remove potential old grid styles if any
}

.lfst {
  // Keep existing left sidebar styles
  width: 80px; // Example width, keep original
  flex-shrink: 0;
}

/* Right Side List Container */
.rigts.game-list-container {
  flex-grow: 1;
  padding:  0;
  overflow-y: auto; 
  overflow-x: hidden;
  box-sizing: border-box;
  // max-height: 590px; /* Change max-height limit to 550px */
}
.rigts-title{
  display: flex;
  align-items: center;
  padding: 10px 0;
  img{
    width: 27px;
  }
  span{
    font-size: 16px;
    color: #333;
  }
}
/* New List Item Styles - Targeting the new design */
.game-card {
  background-color: #ffffff; /* White background */
  // background-image: url('/static/image/game_card_bg.png'); /* Restore background image */
  // background-size: cover; /* Cover the area */
  // background-repeat: no-repeat; /* Restore */
  // background-position: top left; /* Position from top left */
  border-radius: 19px; /* Rounded corners */
  padding: 0; /* Reset padding */
  // box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); /* Softer shadow */
  position: relative; /* Keep for absolute positioning of image */
  cursor: pointer;
  // min-height: 110px; /* Set minimum height to 170px */
  // height: 110px; /* Set fixed height to 170px */
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px; /* Add margin for spacing */
}

.game-card-content {
  /* Apply padding only to the content area */
  padding: 10px 10px 10px 15px; /* Keep basic padding */
  padding-right: 140px; /* Increase padding to reserve more space for image */
  /* Add text overflow styles */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Ensure content is vertically centered if needed (might require line-height or other methods now) */
  height: 100%; /* Make content take full height */
  display: flex; /* Re-add flex just for vertical centering inside content */
  align-items: center;
  /* --- Hide the content visually but keep in DOM --- */
  opacity: 0;
  pointer-events: none; /* Prevent interaction */
  position: relative; /* Ensure it layers correctly if needed */
  z-index: 1; /* Place it conceptually above the image, though invisible */
}

.game-title {
  font-size: 15px;
  font-weight: 600;
  color: #444; /* Keep color definition */
}

.game-card-image {
  width: 100%; /* Make image height 100% of the card */
  // width: 100%; /* Make image width 100% of the card */
  // object-fit: cover; /* Cover the area, maintaining aspect ratio */
  border-radius: 0; 
  // position: absolute;
  // top: 0;
  // left: 0; /* Ensure image starts from the left edge */
}

/* Loading/Empty Placeholder Styles */
.loading-placeholder {
    padding: 20px;
    text-align: center;
    color: #888;
    font-size: 14px;
}
.domainModal_domainView__FWCzg .domainModal_mask__24Y2m{
  background-color: rgba(0, 0, 0, .7)!important;
  position: relative;
  
}
.closeDom{
    position: absolute;
    width: 34px;
    height: 34px;
    -webkit-transform: translate(-50%,-50%);
 
    z-index: 999;
    top: 111px;
    left:48%;
  }
/* Wrapper for Hot Games Area */
.hot-games-wrapper {
  padding: 0 6px; /* Reduced side padding */
}

/* Wrapper for Other Games List */
.other-games-wrapper {
  padding: 0 6px; /* Reduced side padding */
}

/* Wrapper for Loading Placeholder */
.loading-placeholder-wrapper {
  padding: 0 6px; /* Apply padding here, reduced */
  width: 100%; /* Ensure it takes full width */
  box-sizing: border-box;
}

.refresh-btn {
  width: 20px;
  height: 20px;
  margin-left: 8px;
  cursor: pointer;
  display: inline-block;
  // vertical-align: middle;
}

.top-download-btn {
  // position: absolute;
  top: 10px;
  right: 24px;
  z-index: 9;
  background: #866638;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: .8em;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: background 0.2s;
}
.top-download-btn:hover {
  background: #b86b4b;
}
.van-swipe{
  width: 94%;
  border-radius: 10px;
  overflow: hidden;
  margin: 0 auto;
  // height: 110px;
}
::v-deep .van-swipe__indicator {
  width: 20px;
  height: 3px;
  border-radius: 2px;
  background: rgba(255,255,255,0.5);
}

::v-deep .van-swipe__indicator--active {
  width: 30px;
  background: white;
}
.van-notice-bar{
  padding: 0 4px;
}
.jiangchi{
  background-color: #ffffff; /* White background */
  background-image: url('/static/style/1912120452559618049.avif'); /* Restore background image */
  background-size: 100%; /* Cover the area */
  background-repeat: no-repeat; /* Restore */
  background-position: center center; /* Position from top left */
  padding: 0; /* Reset padding */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); /* Softer shadow */
  position: relative; /* Keep for absolute positioning of image */
  cursor: pointer;
  min-height: 106px; /* Set minimum height to 170px */
  overflow: hidden;
  width: 94%;
  margin: 0 auto;
  box-sizing: border-box;
  .num{
     text-align: center;
     width: 100%;
     font-size: 18px;
    // text-shadow: 0px 3px 2px rgb(141 44 0 / 50%);
    display: block;
    padding-top: 52px;
    // letter-spacing: 2px;
  font-weight: 400;
  color: #f7ff8b;
  font-style: italic;
  transform: skew(-0deg, -0deg);
  text-shadow: 
    /* 红色描边 */
    -1px -1px 0 #FF0000,
    1px -1px 0 #FF0000,
    -1px 1px 0 #FF0000,
    1px 1px 0 #FF0000,
    -1px -1px 0 #CC0000,
    1px -1px 0 #CC0000,
    -1px 1px 0 #CC0000,
    1px 1px 0 #CC0000,
    /* 3D立体效果 */
    0 2px 0 #fad475,
    0 2px 0 #fad475,
    0 3px 0 #fad475,
    0 3px 0 #fad475;
    /* 投影 */
    // 0 8px 15px rgba(0, 0, 0, 0.8),
    // 0 12px 20px rgba(0, 0, 0, 0.6),
    // 0 16px 25px rgba(0, 0, 0, 0.4);
  font-family: 'Arial Black', Arial, sans-serif;
  letter-spacing: 2px;
  white-space: nowrap;
  }
}
.fixedDiv{
  position: sticky;
  right: 0;
 bottom: 0;
 z-index: 12;
}
.kefu{
  // position: fixed;
  right: 0;
  bottom: 230px;
  position: absolute;
  .tg{
    width: 66px;
    height: 66px;
  }
  .tgClose{
    width: 22px;
    height: 22px;
    position: absolute;
    right: 0;
  }
}
.kefu1{
  // position: fixed;
  position: absolute;
  right: 0;
  bottom: 140px;
  .tg{
    width: 66px;
    height: 66px;
  }
  .tgClose{
    width: 22px;
    height: 22px;
    position: absolute;
    right: 0;
  }
}
.ding{
  position: absolute;
  bottom: 70px;
  right: 0;
  background-color: #fff;
      border-radius: 50%;
      border:1px solid #e3e3e3;
      border-radius: 0.1rem;
      box-shadow: 0.02rem 0 0.06rem rgb(0 0 0 / 10%);
      width: 56px;
      height: 56px;
      cursor: pointer;
    padding-top: 8px;      
    box-sizing: border-box;
  ._iconWrap_1q2kk_44{
        display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      background: #866638;
      border-radius: 100%;
      width: 20px;
      height: 20px;
  }
  .dingtext{
        text-align: center;
        width: 100%;
        color: #666;
      }
}

.nei{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .nei_list{
    width: 20%;
    margin-bottom: 15px;
    img{
      width: 29px;
      height: 26px;
      display: block;
      margin: 0 auto 4px;
    }
    span{
      display: block;
      text-align: center;
      font-size: 12px;
      color: #666;
    }
  }
}
.topAppApp{
  position: sticky;
  top: 0;
  height: auto;
  left: 0;
  background: #fff;
   width:100%;
   z-index: 11;
}
.app{
  // padding-top: 93px;
}
.topsa{
  margin-left: 10px;
  border-bottom: 1px solid #e3e3e3;
      padding-left: 28px;
}




._home-layout_x27ue_30 ._main_x27ue_33>div {
    margin-top: .2rem;
}
._footerBox_a30j0_30 {
    padding: .2rem .2rem .4rem;
    background-color: #f8f8f8;
}
._link-list-box_1gpjz_30 {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: thin solid #e3e3e3;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 {
    display: flex
;
    flex-wrap: wrap;
    row-gap: .1rem;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 {
    overflow: hidden;
    width: 33.33%;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._title_1gpjz_35 {
    margin-bottom: .2rem;
}
._link-list-box_1gpjz_30 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._title_1gpjz_35 {
    margin-bottom: .2rem;
    color: var(--skin__neutral_2);
    font-size: 13px;
}
._link-list-box_1gpjz_30 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._item-list_1gpjz_40 ._item_1gpjz_35 {
    margin-bottom: 8px;
    color: #666666;
    font-size:13px;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._item_1gpjz_35 {
    margin-bottom: .1rem;
    color: var(--skin__neutral_1);
    font-size: .16rem;
    max-width: 2.2rem;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
._link-list-box_1gpjz_30 .license-compliance {
    margin-top: 16px;
}
._license-compliance_ablfx_30 ._title_ablfx_30 {
    margin-bottom: 12px;
    color:#999;
    font-size: 13px;
}
._license-compliance_ablfx_30 ._license-compliance-list_ablfx_35{
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}
._channel-box_1tgxg_30 {
    width: 100%;
    margin-bottom: 21px;
    padding-bottom: 7px;
    border-bottom: thin solid #e3e3e3;
}
._channel-box_1tgxg_30 ._title_1tgxg_36 {
    margin-bottom:15px;
    display: inline-block;
    color:#999;
    font-size: 13px;
}
._channel-box_1tgxg_30 ._channel-items_1tgxg_42 {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding-bottom:12px;
    box-sizing: content-box;
}
._channel-box_1tgxg_30 ._channel-items_1tgxg_42 ._channel-item_1tgxg_42 {
    width: 28px;
    height: 28px;
}
._contactus-box_18kto_43 {
    border-bottom: thin solid #e3e3e3;
    padding-bottom: 12px;
    margin-bottom: 12px;
}
._contact-us-title_18kto_54 {
    margin-bottom: 8px;
    color: #999;
    font-weight: 400;
    font-size:13px;
}
._contactUs_18kto_30 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}
._contactUs_18kto_30 ._socialItem_18kto_36 {
    color: inherit;
}
._contactUs_18kto_30 ._socialItem_18kto_36 img {
    display: block;
    max-width: 100%;
}
.link-list-title{
  color: #999999!important;
}
.downApp{
  display: flex;
  align-items: center;
  padding: 10px 0;
  img{
    width: 82px;
    height: 82px;
  }
  .downAppText{
    .text1{
      color: #041d76;
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
    }
    .text2{
          color: #e03e2d;
          font-size: 18px;
          font-weight: bold;
          padding: 2px 0;
          text-align: center;
          line-height: 1;
    }
    .text3,.text4{
      text-align: center;
          color: #041d76;
      font-size: 16px;
      font-weight: bold;
      padding: 1px 0;
      line-height: 1;
      span{
        color: red;
        font-weight: bold;
      }
    }

  }
}
.downbtn{
  display: flex;
  justify-content: space-around;
  .downbtn_left{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #866638;
    box-sizing: border-box;
    border: 1px solid #866638;
    width: 46%;
    height: 34px;
    border-radius: 6px;
  }
  .downbtn_right{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    box-sizing: border-box;
    border: 1px solid #866638;
    width: 50%;
    height: 34px;
    border-radius: 6px;
    background: #866638;
  }
}
.container {
    display: flex;
    // height: 100vh;
    // overflow: hidden;
    padding: 0 20px;
  }
  
  .sidebar {
    width:82px;
    // overflow-y: auto;
  
  }
  
  .sidebar ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar li {
  //   padding: 12px 16px;
    cursor: pointer;
  //   border-left: 3px solid transparent;
    transition: all 0.3s;
    text-align: center;
        border-radius: 4px;
        padding: 4px 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
        // min-height: 60px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // background: #f5f0e294;
        background: url('/static/image/btn_zc1_2.avif') no-repeat center center;
        background-size: 100%;
        width: 78px;
        height: 36px;
        // justify-content: center;
        color: #666;
        img {
          width: 30px;
          height: 25px;
          display: block;
          // margin: 0 auto;
        }
        span {
          font-size: 10px;
          display: block;
          margin-top: 3px;
          // color: #666;
        }
  }
  
  .sidebar li.active {
    background-color: #e0e0e0;
    border-left-color: #409eff;
    color: #409eff;
  }
  
  .content {
    // flex: 1;
    // overflow-y: auto;
    padding: 20px 0 20px 10px;
  }
  .scrAciveC{
    margin-left: 78px;
  }
  .scrAcive{
    position: fixed;
    left:20px;
  }
  @media screen and (min-width:413px) {
    .scrAcive{
      position: fixed;
      left:calc(50% - 186px);
    }
  }
  .section {
    border-bottom: 1px solid #eee;
  }
  
  .section h2 {
    margin-top: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  
  .section ul {
    list-style: none;
    padding: 0;
  }
  
  .section li {
    padding: 8px 0;
    border-bottom: 1px solid #f5f5f5;
  }
  .section li .img{
    width: 100%;
    border-radius: 8px;
  }
  
  .section li:last-child {
    border-bottom: none;
  }
  .remen{
    border-bottom: 1px solid #e3e3e3;
    position: relative;
    .remen_text{
      font-size: 12px;
      color: #866638;
      border-bottom: 2px solid #866638;
      padding-bottom: 6px;
      width: 28px;
      text-align: center;
      margin-left: 35px;
    }
    .remen_xian{

    }
    img{
      position: absolute;
      right: 0;
      top: -4px;
      width: 30px;
      height: 30px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue